export function assembleLinkForMatchedRecord(
  matchedRecord: Record<string, string> | null,
  module: string,
  accountMappings
): string | null {
  if (
    matchedRecord == null ||
    matchedRecord?.recordId == null ||
    matchedRecord?.projectId == null
  ) {
    return null
  }
  const account = accountMappings.find(am =>
    am.projects.some(p => p.projectId === matchedRecord.projectId)
  )
  if (account != null) {
    return `/accounts/${account.accountId}/projects/${matchedRecord.projectId}/${module}/record/${matchedRecord.recordId}/edit`
  } else {
    return `/404`
  }
}
